/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/books.scss';
import Tab from '../../component/Inc/Tab';
import Calendar from '../../component/Inc/Calendar';
import PopBookCompany from './_PopBookCompany';
import PopDeposit from './_PopDeposit';

const RefundDetail = () => {
  const [modalBookCompanyOpen, setModalBookCompanyOpen] = useState(false);
  const [modalDepositOpen, setModalDepositOpen] = useState(false);
  //Tab Component
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '발송', value: 1},
    {title: '반품', value: 2}
  ];

  return (
    <main className="com_container p_refund_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu3_10 ">
            총판발송 / 반품내역
            <span className="bar" />
            <span className="point_txt">서울 제일총판 (공급가 : 50%ㆍ채택가 : 40%)</span>
          </h2>
          <button onClick={() => setModalBookCompanyOpen(true)} className="com_btn orange s btn_plus">
            총판 관리
          </button>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />

              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>

            <hr className="com_divider" />
            <div className="com_calendar_wrap">
              <Calendar />
            </div>

            <div className="com_table_wrapper">
              <table className="com_board_list ">
                <colgroup>
                  <col width="{{ width: 'calc(100% / 9)' }}" />
                  <col width="{{ width: 'calc(100% / 9)' }}" />
                  <col width="{{ width: 'calc(100% / 9)' }}" />
                  <col width="{{ width: 'calc(100% / 9)' }}" />
                  <col width="{{ width: 'calc(100% / 9)' }}" />
                  <col width="{{ width: 'calc(100% / 9)' }}" />
                  <col width="{{ width: 'calc(100% / 9)' }}" />
                  <col width="{{ width: 'calc(100% / 9)' }}" />
                  <col width="{{ width: 'calc(100% / 9)' }}" />
                </colgroup>
                <thead>
                  <tr>
                    <th>총 발송 권 수</th>
                    <th>총 발송 금액</th>
                    <th>
                      <button className="arrow active" />
                      발송 권 수
                    </th>
                    <th>
                      <button className="arrow active" />총 반품 금액
                    </th>
                    <th>실 매출액</th>
                    <th>실 입금액</th>
                    <th>잔액</th>
                    <th>조정 금액</th>
                    <th>현 잔액</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>45</td>
                    <td className="td_point">78,450,000</td>
                    <td>20</td>
                    <td className="td_red">- 350,000</td>
                    <td className="td_point">450,000</td>
                    <td>450,000</td>
                    <td>310,000</td>
                    <td className="td_point td_width">
                      645,000
                      <button className="btn_edit" />
                    </td>
                    <td className="td_red">450,000</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="com_table_wrapper">
              <table className="com_board_list ">
                <colgroup>
                  <col width="70" />
                  <col width="135" />
                  <col width="135" />
                  <col width="135" />
                  <col width="auto" />
                  <col width="135" />
                  <col width="135" />
                  <col width="135" />
                  <col width="135" />
                  <col width="135" />
                </colgroup>
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>구분</th>
                    <th>
                      <button className="arrow active" />
                      발송, 반품일
                    </th>
                    <th>
                      <button className="arrow active" />
                      발송자
                    </th>
                    <th>
                      <button className="arrow active" />
                      교재 명
                    </th>
                    <th>
                      <button className="arrow active" />
                      발송, 반품 권 수
                    </th>
                    <th>판매가</th>
                    <th>공급가</th>
                    <th>채택가</th>
                    <th>비고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>발송</td>
                    <td>2023, 05, 12</td>
                    <td>김발송103</td>
                    <td>13221 과학{3} 즐거운 과학</td>
                    <td>30</td>
                    <td>10,000</td>
                    <td className="td_point">5,000</td>
                    <td></td>
                    <td className="td_point">채택</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>발송</td>
                    <td>2023, 05, 12</td>
                    <td>김발송103</td>
                    <td>13221 과학{3} 즐거운 과학</td>
                    <td>30</td>
                    <td>10,000</td>
                    <td></td>
                    <td className="td_point">4,000</td>
                    <td className="td_point">채택</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>발송</td>
                    <td>2023, 05, 12</td>
                    <td>김발송103</td>
                    <td>13221 과학{3} 즐거운 과학</td>
                    <td>30</td>
                    <td>10,000</td>
                    <td className="td_point">7,000</td>
                    <td></td>
                    <td className="td_point">채택</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>발송</td>
                    <td>2023, 05, 12</td>
                    <td>김발송103</td>
                    <td>13221 과학{3} 즐거운 과학</td>
                    <td>30</td>
                    <td>10,000</td>
                    <td></td>
                    <td className="td_point">4,000</td>

                    <td className="td_point">채택</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td className="td_red">발송</td>
                    <td>2023, 05, 12</td>
                    <td>김발송103</td>
                    <td>13221 과학{3} 즐거운 과학</td>
                    <td>30</td>
                    <td>10,000</td>
                    <td className="td_red">-103,000</td>
                    <td></td>
                    <td className="td_point">채택</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>발송</td>
                    <td>2023, 05, 12</td>
                    <td>김발송103</td>
                    <td>13221 과학{3} 즐거운 과학</td>
                    <td>30</td>
                    <td>10,000</td>
                    <td className="td_point">5,000</td>
                    <td></td>
                    <td className="td_point">채택</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>발송</td>
                    <td>2023, 05, 12</td>
                    <td>김발송103</td>
                    <td>13221 과학{3} 즐거운 과학</td>
                    <td>30</td>
                    <td>10,000</td>
                    <td className="td_red">-103,000</td>
                    <td></td>
                    <td className="td_point">채택</td>
                  </tr>
                  <tr className="summarized_rows">
                    <td colSpan="2"></td>
                    <td>2023</td>
                    <td></td>
                    <td className="td_point">42종</td>
                    <td className="td_point">15,000</td>
                    <td className="td_point">15,000</td>
                    <td className="td_point">15,000</td>
                    <td>15,000</td>
                    <td></td>
                  </tr>
                  <tr className="summarized_rows">
                    <td colSpan="2"></td>
                    <td>2022</td>
                    <td></td>
                    <td className="td_point">42종</td>
                    <td>15,000</td>
                    <td>15,000</td>
                    <td>15,000</td>
                    <td>15,000</td>
                    <td></td>
                  </tr>

                  <tr className="summarized_rows">
                    <td colSpan="2"></td>
                    <td>증감율</td>
                    <td></td>
                    <td className="td_point">
                      <span className="arrow_blue up">465</span>
                    </td>
                    <td className="td_point">
                      <span className="arrow_blue up">465</span>
                    </td>
                    <td className="td_point">
                      <span className="arrow_blue up">465</span>
                    </td>
                    <td className="td_point">
                      <span className="arrow_blue up">465</span>
                    </td>
                    <td className="td_point">
                      <span className="arrow_blue up">465</span>
                    </td>
                    <td className="td_point">
                      <span className="arrow_blue up">465</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="com_btn_wrap right">
                <button className="com_btn black  btn_down_orange">거래명세서 다운로드</button>
                <button className="com_btn black xs btn_down_orange">다운로드</button>
              </div>
            </div>

            <hr className="com_divider" />

            <div className="com_table_wrap">
              <section className="com_tit_wrap">
                <div className="detail_tit dot">입금내역</div>
                <button onClick={() => setModalDepositOpen(true)} className="com_btn orange xs wl">
                  입금하기
                </button>
              </section>

              <table className="com_board_list ">
                <colgroup>
                  <col width="{{ width: 'calc(100% / 5)' }}" />
                  <col width="{{ width: 'calc(100% / 5)' }}" />
                  <col width="{{ width: 'calc(100% / 5)' }}" />
                  <col width="{{ width: 'calc(100% / 5)' }}" />
                  <col width="{{ width: 'calc(100% / 5)' }}" />
                </colgroup>
                <thead>
                  <tr>
                    <th className="arrow ">입금일</th>
                    <th>입금자</th>
                    <th>등록자</th>
                    <th>임금액</th>
                    <th>입금방법</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>2023, 05, 10</td>
                    <td>홍길동</td>
                    <td>김관리103</td>
                    <td className="td_point">40,000</td>
                    <td>하나은행 10321-31245364</td>
                  </tr>
                  <tr>
                    <td>2023, 05, 10</td>
                    <td>홍길동</td>
                    <td>김관리103</td>
                    <td className="td_point">40,000</td>
                    <td>하나은행 10321-31245364</td>
                  </tr>
                  <tr>
                    <td>2023, 05, 10</td>
                    <td>홍길동</td>
                    <td>김관리103</td>
                    <td className="td_point">40,000</td>
                    <td>하나은행 10321-31245364</td>
                  </tr>
                  <tr className="summarized_rows">
                    <td></td>
                    <td></td>
                    <td>총 입금액</td>
                    <td className="td_point">654,000</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
      <PopBookCompany open={modalBookCompanyOpen} close={() => setModalBookCompanyOpen(false)} />
      <PopDeposit open={modalDepositOpen} close={() => setModalDepositOpen(false)} />
    </main>
  );
};

export default RefundDetail;
